import styled from "styled-components";
import { Button } from "@mui/material";

export const StyledItsMeBtn = styled(Button)`
    box-sizing: border-box;
    height: 40px;
    margin-top: 24px;
    background-color: var(--color-itsme) !important;
    border: 1px solid var(--color-itsme);
    border-radius: var(--radius-5);

    path {
        &:last-child {
            fill: var(--color-itsme);
        }
    }

    &:disabled {
        color: var(--color-white);
        background-color: var(--color-grey-700) !important;
        border: none;

        path {
            &:last-child {
                fill: var(--color-grey-700);
            }
        }
    }

    &:hover {
        background-color: #f23905 !important;
    }
`;

export const StyledItsMeTxt = styled.span`
    display: flex;
    align-items: center;
    margin-left: 8px;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: bold;
    line-height: 22px;
    color: var(--color-white);
    text-align: center;
    text-transform: none;
`;
